export const FETCH_PAYMENTS_INIT_ACTION =
  "FETCH_PAYMENTS_INIT_ACTION";
export const FETCH_PAYMENTS_SUCCESS_ACTION =
  FETCH_PAYMENTS_INIT_ACTION + "_SUCCESS";
export const FETCH_PAYMENTS_FAIL_ACTION =
  FETCH_PAYMENTS_INIT_ACTION + "_ERROR";

export function getPayments(value) {
  return {
    type: FETCH_PAYMENTS_INIT_ACTION,
    value:value,
  };
}

export function PaypageSelected(value){
    return {
        type: FETCH_PAYMENTS_INIT_ACTION,
        value:value,
    }
}
